import slugify from "@sindresorhus/slugify";
import {Stack} from "@mantine/core";
import {t} from "i18next";
import {dibAppApi} from "../../dibAppApi/dibAppApi";
import {DibObjectRelated, RelatedCategories} from "./types";
import PATHS, {TOPIC_TYPE_PATHS, TOPIC_TYPE_DB_NAMES} from "../../paths";
import {ExperimentalLink} from "../../components/ExperimentalLink";
import {RelatedGroup, RelatedItem} from "../../components/related-list";
import IconListCheck from "../../assets/list-check.svg?react";
import IconVocabulary from "../../assets/vocabulary.svg?react";

const getRelatedContentURL = (object: DibObjectRelated) => {
    const topicTypeId = object.data.topictypeId;
    const urlName = slugify(object.data.name);
    const topicId = object.data.dataResourceId;
    if (topicTypeId in TOPIC_TYPE_PATHS) {
        const tsSafeTopicTypeId = Number(
            topicTypeId
        ) as keyof typeof TOPIC_TYPE_PATHS;
        return `${PATHS.ROOT}${TOPIC_TYPE_PATHS[tsSafeTopicTypeId]}/${urlName}/${topicId}`;
    }
    return `${PATHS.ROOT}${PATHS.NOT_IMPLEMENTED}/${urlName}/${topicId}`;
};

export const RelatedContent = ({
    resourceId,
    segmentId,
}: {
    resourceId: string;
    segmentId: string | undefined;
}) => {
    const {data: documentData} = dibAppApi.endpoints.getDocument.useQuery({
        resourceId,
        segmentId,
    });

    if (
        !documentData ||
        !documentData.relatedroot ||
        documentData.relatedroot.length === 0
    ) {
        return null;
    }

    const tools: DibObjectRelated[] = [];
    const content: DibObjectRelated[] = [];

    documentData.relatedroot
        .map((id) => documentData.objects[id])
        .forEach((obj) => {
            if (obj.type === "related") {
                if (obj.data.categoryId === RelatedCategories.TOOLS) {
                    tools.push(obj);
                } else {
                    content.push(obj);
                }
            }
        });

    if (tools.length === 0 && content.length === 0) {
        return null;
    }

    const renderToolItem = (item: DibObjectRelated) => (
        <RelatedItem
            title={item.data.name}
            description={TOPIC_TYPE_DB_NAMES[item.data.topictypeId] || null}
            href={getRelatedContentURL(item)}
            linkComponent={ExperimentalLink}
            linkProps={{transition: false}}
        />
    );

    const renderContentItem = (item: DibObjectRelated) => (
        <RelatedItem
            title={item.data.name}
            href={getRelatedContentURL(item)}
            linkComponent={ExperimentalLink}
            linkProps={{transition: false}}
        />
    );

    return (
        <Stack gap="xl">
            <RelatedGroup
                icon={
                    <IconListCheck
                        style={{width: "1.2rem", height: "1.2rem"}}
                    />
                }
                title={t("topicSidebar.ToolsHeading")}
                items={tools}
                renderItem={renderToolItem}
                keyExtractor={(item) => item.id}
            />
            <RelatedGroup
                icon={
                    <IconVocabulary
                        style={{width: "1.2rem", height: "1.2rem"}}
                    />
                }
                title={t("topicSidebar.OtherHeading")}
                items={content}
                renderItem={renderContentItem}
                keyExtractor={(item) => item.id}
            />
        </Stack>
    );
};
